<template>
  <el-skeleton :loading="false" :rows="16" animated>

    <el-page class="home-page">
      <div class="home-banner">
        <swiper class="swiper-box" :options="swiperOption">
          <swiper-slide class="swiper-item-wrapper" v-for="item in bannerList" :key="item.id">
            <div class="swiper-item" @click="jumpDetail(item)">
              <div class="swiper-item-image">
                <img v-if="!!item.pcImgUrl" :src="item.pcImgUrl" />
              </div>
            </div>
          </swiper-slide>
          <div v-if="bannerList.length > 0" class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="home-concept">
        <pane-title class="pane" title="投资创造美好生活" subTitle="INVESTING FOR A BETTER LIFE" />
        <div class="image-container">
          <div :key="index" class="image-wrapper" v-for="(item, index) in conceptList">
            <img class="image" :src="item.pcImgUrl" />
            <img class="mobile-image" :src="item.mbImgUrl" />
          </div>
        </div>
      </div>
      <!-- <div class="home-strategies">
        <pane-title class="pane" title="投资策略" subTitle="INVESTMENT STRATEGIES" />
        <div class="strategy-container">
          <div :key="index" class="strategy-image" v-for="(item, index) in strategiesList">
            <img :src="item.pcImgUrl" />
          </div>
        </div>
      </div>
      <div class="home-board">
        <pane-title class="pane" title="数据看板" subTitle="DATA BOARD" />
        <div class="board-container">
          <div class="board-content">
            <div class="board-item">
              <div class="description">成立时间</div>
              <div class="title">{{ boardData.foundDate || '--' }}</div>
            </div>
            <div class="board-item">
              <div class="description">管理规模</div>
              <div class="title">{{ boardData.scale || '--' }}</div>
            </div>
            <div class="board-item">
              <div class="description">投资覆盖领域</div>
              <div class="title">{{ boardData.field || '--' }}</div>
            </div>
            <div class="board-item">
              <div class="description">合作单位(政府与行业机构)</div>
              <div class="title">{{ boardData.cooperator || '--' }}</div>
            </div>
          </div>
          <div :key="index" class="board-image" v-for="(item, index) in boardList">
            <img :src="item.pcImgUrl" />
          </div>
        </div> -->
      </div>
    </el-page>
  </el-skeleton>
</template>

<script>
import PaneTitle from '../../components/PaneTitle/PaneTitle.vue';
export default {
  components: { PaneTitle },
  data() {
    return {
      loading: true,
      swiperOption: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        loop: true, // 循环滚动
        slidesPerView: 1,
        spaceBetween: 0,
        observer: true,         // 监听自身变化
        observeParents: true,   // 监听父级变化
        watchOverflow: true, // 当滑块数量不足时自动隐藏分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      },
      bannerList: [],
      conceptList: [],
      strategiesList: [],
      boardData: { foundDate: '', scale: '', field: '', cooperator: '' },
      boardList: []
    };
  },
  methods: {
    jumpDetail(item) {
      const link = item.jumpUrl;
      if (link === 'local') {
        window.open('/news-detail/' + item.id);
      } else if (link) {
        window.open(link)
      }
    },
    configData(record) {

      this.bannerList = (record['10'] || []).sort((a, b) => a.sort - b.sort)
      this.conceptList = (record['11'] || []).sort((a, b) => a.sort - b.sort)
      // this.strategiesList = (record['12'] || []).sort((a, b) => a.sort - b.sort)
      // const [foundDate, scale, field, cooperator] = ((record['14'][0] || {}).content || '').split('|') || []
      // this.boardData = { foundDate, scale, field, cooperator }
      // this.boardList = (record['13'] || []).sort((a, b) => a.sort - b.sort)

    },
    getData(language) {
      this.$http.getOnlyContent({
        itemType: '1',
        platform: 'pc',
        language
      }).then(res => {
        this.loading = false;
        this.configData(res.crmOweContentMaps || {})
      });
    },
    getDataByLang(lang) {
      if (lang === 'zh') {
        this.getData('china');

      } else {
        this.getData('english');
        this.getNewsData('english');
      }
    },
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    filteredGroups() {
      return this.groups.filter(group => group.items.length > 0);
    }
  },
  watch: {
    "$i18n.locale": {
      immediate: true,
      handler(v) {
        this.getDataByLang(v);
      }
    },
  }
};
</script>


<style scoped lang="less">
.home-page {

  .swiper-box {
    /deep/ .swiper-pagination {
      .swiper-pagination-bullet {
        background-color: fade(white, 40);
      }

      .swiper-pagination-bullet-active {
        background-color: white;
      }
    }

    .swiper {

      &-item {
        cursor: pointer;
        position: relative;

        &-image {
          background-color: var(--placehoder-color);
          width: 100%;
          aspect-ratio: 1920 / 586;

          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }


  .pane {
    margin: 3rem 0;
  }

  .home-concept {
    padding-bottom: 9rem;

    .image-container {
      display: flex;
      justify-content: center;
      gap: 1rem;
      padding: 0 15rem;
    }

    .image {
      display: block;
    }

    .mobile-image {
      display: none;
    }

    .image-wrapper {
      flex: 1;
      aspect-ratio: 469 / 336;
      overflow: hidden;
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.05);
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .home-strategies {
    .strategy-container {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    .strategy-image {
      width: 100%;
      margin: 0;
      padding: 0;
      margin-top: 1rem;

      &:first-child {
        margin: 0 15rem;
        margin-top: 0;
        width: calc(100% - 24rem);
      }

      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }
  }

  .home-board {
    .board-container {
      padding: 0 15rem;

    }

    .board-content {
      display: flex;
      justify-content: center;
      gap: 1rem;
      margin-bottom: 1rem;
    }

    .board-item {
      box-sizing: border-box;
      flex: 1;
      aspect-ratio: 348/195;
      background-color: #F6F6F6;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: left;
      padding: 0 2rem;
      transition: all 0.3s ease;
      border: 1px solid transparent;

      .description {
        font-size: 1rem;
        color: #666;
        margin-bottom: 2rem;
        transition: color 0.3s ease;
      }

      .title {
        font-size: 3rem;
        color: #037698;
        font-weight: bold;
        transition: transform 0.3s ease;
      }

      &:hover {
        background-color: white;
        border: 1px solid #037698;
        transform: translateY(-0.5rem);
        box-shadow: 0 5px 15px rgba(3, 118, 152, 0.1);

        .description {
          color: #037698;
        }

        .title {
          transform: scale(1.05);
        }
      }
    }

    .board-image {
      width: 100%;
      margin: 0;

      margin: 1rem 0;

      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }
  }

}


/* 小屏幕（移动端） */
@media screen and (max-width: 767px) {

  .home-page {
    .home-banner {
      margin: 0 -1.33rem;
    }

    .home-concept {
      padding-bottom: 3.25rem;

      .image {
        display: none;
      }

      .mobile-image {
        display: block;
      }

      .image-wrapper {
        aspect-ratio: 343/162;
      }
    }

    .swiper-box .swiper-item-image {
      aspect-ratio: 375 / 197;
    }

    .home-concept .image-container {
      flex-direction: column;
      padding: 0;
    }
  }
}
</style>